import {Clock} from 'three'
import {Object3D, Group} from 'three'

type Repaint = () => void

/**
 * Компонент для управления анимацией объектов
 * Использует композицию вместо наследования (лучшая инкапсуляция)
 */
export class AnimationManager {
  private clock: Clock = new Clock()
  private animationFrameId: number | null = null
  private repaint: Repaint | null = null
  private animatedObjects: Set<Object3D> = new Set()

  /**
   * Инициализация функции перерисовки
   */
  initRepaint(repaint: Repaint): void {
    this.repaint = repaint
  }

  /**
   * Добавление объекта для анимации
   */
  addAnimatedObject(object: Object3D): void {
    this.animatedObjects.add(object)
    this.startAnimationLoop()
  }

  /**
   * Удаление объекта из анимации
   */
  removeAnimatedObject(object: Object3D): void {
    this.animatedObjects.delete(object)
    if (this.animatedObjects.size === 0) {
      this.stopAnimationLoop()
    }
  }

  /**
   * Очистка всех анимированных объектов
   */
  clearAll(): void {
    this.animatedObjects.clear()
    this.stopAnimationLoop()
  }

  /**
   * Запуск цикла анимации
   */
  private startAnimationLoop(): void {
    if (this.animationFrameId !== null) {
      return
    }

    const animate = () => {
      const delta = this.clock.getDelta()

      this.animatedObjects.forEach((object) => {
        if (
          'topModelsGroup' in object &&
          object.topModelsGroup instanceof Group
        ) {
          object.topModelsGroup.rotation.y += delta * 0.5
        }
      })

      this.animationFrameId = requestAnimationFrame(animate)
    }

    this.animationFrameId = requestAnimationFrame(animate)
  }

  /**
   * Остановка цикла анимации
   */
  stopAnimationLoop(): void {
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId)
      this.animationFrameId = null
    }
  }

  /**
   * Получение функции repaint (для обратной совместимости)
   */
  getRepaint(): Repaint | null {
    return this.repaint
  }
}
